/** Degrees of longitude across the view at which zooming out switches to the globe. */
export const GLOBE_ENTER_SPAN_DEGREES = 90;
/** Degrees of longitude across the view at which zooming in switches back to the map. */
export const GLOBE_EXIT_SPAN_DEGREES = 60;

export const longitudeSpan = (bounds: { west: number; east: number }): number => {
  const span = bounds.east - bounds.west;
  if (span < 0) {
    return span + 360;
  }
  return Math.min(span, 360);
};

export type GlobeSpans = { enter: number; exit: number };
const DEFAULT_GLOBE_SPANS: GlobeSpans = {
  enter: GLOBE_ENTER_SPAN_DEGREES,
  exit: GLOBE_EXIT_SPAN_DEGREES,
};

export const nextGlobeMode = (
  isGlobe: boolean,
  lonSpan: number,
  spans: GlobeSpans = DEFAULT_GLOBE_SPANS,
): boolean => {
  if (isGlobe) {
    return lonSpan > Math.min(spans.exit, spans.enter);
  }
  // SDK camera normalization can land just inside the street zoom limit.
  return lonSpan >= spans.enter * 0.99;
};
